import { baseThemeValues } from 'constants/common';

const headingFont = (fontSize: string) => ({
  fontFamily: baseThemeValues.inherit,
  fontSize,
  fontWeight: 600,
  text: 'palette.tertiary.95',
});

export const markdownContentTheme = {
  code: {
    bg: 'palette.surface.3',
    borderRadius: '6px',
    text: 'palette.tertiary.95',
  },
  h1: headingFont('28px'),
  h2: headingFont('26px'),
  h3: headingFont('24px'),
  link: {
    text: 'palette.primary.50',
  },
  text: 'palette.tertiary.95',
};
